import { Button } from '@mui/material';
import { Box, Container } from '@mui/system';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';
import { AppModels, appUrl, Lang, UserAttrs, userSelector, userSlice } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EditableTextGridCell, SimGrid } from '../../libraries/grid/SimGrid';
import { MainSimpleViewLoader } from '../../libraries/MainViewLoader';
import { useSession } from '../../libraries/SessionProvider';
import { RootState } from '../../store';
import { UserRoleGridItem } from '../grid/UserRoleGridItem';
import { MasterViewPage } from '../MasterPage';
import { CreateUserView } from './CreateUser';

const columns: GridColDef<UserAttrs>[] = [
    {
        field: 'name',
        headerName: 'Prénom et nom',
        flex: 1,
        editable: false,
        cellClassName: 'editableText',
        renderCell: EditableTextGridCell,
    },
    {
        field: 'roles',
        headerName: 'Accès',
        editable: false,
        flex: 1,
        renderCell: UserRoleGridItem
    }
];

export const Users = () => {

    return <MasterViewPage><MainSimpleViewLoader
        path='user/list'>
        <LoadedUsers />
    </MainSimpleViewLoader>
    </MasterViewPage>;
};

const LoadedUsers = () => {
    const users = useSelector((state: RootState) => userSelector.selectAll(state));

    const { isSuperAdmin } = useSession();
    const navigate = useNavigate();
    const [createUser, setCreateUser] = React.useState(false);
    return <>
        {createUser && <CreateUserView onClose={() => setCreateUser(false)} />}
        <Container maxWidth={false}>
            {isSuperAdmin && <Box sx={{ width: '100%', m: 1 }}>
                <Button variant='outlined' onClick={() => setCreateUser(true)}>Nouvel {Lang('user')}</Button>
            </Box>}
            <Box sx={{ width: '100%', backgroundColor: 'white' }}>
                <SimGrid
                    gridId={'users'}
                    modelName={AppModels.users}
                    slice={userSlice}
                    columns={columns}
                    rows={users}
                    hideFooter={true}
                    rowSelection
                    onRowClick={(params: GridRowParams<UserAttrs>) => {
                        navigate(appUrl('user', { id: params.row.id }));
                    }}
                />
            </Box>
        </Container>
    </>;
};
